import __base_store from '@/store/__base_store'

/**
 * Store de recargos.
 */
export default __base_store({
	state: {
		model_name: 'surchage',
		per_page: 25,
	},
})

